import { get, extractResponseBodyAsJSON } from 'oneflow-client/core';

export const getExportLink = ({ accountId, assetId, extension }) => (
  get({
    url: `/accounts/${accountId}/exports/${assetId}.${extension}`,
    body: {},
  }).then(extractResponseBodyAsJSON)
);
